
import * as React from "react";

import "./confirm-dialog.scss";

import {cs}          from "@Common/react/chain-services";
import {Link}        from "@Common/react/cst2";
import {upperCase1}  from "@Common/utils/strings";
import {waitTimeout} from "@Common/utils/wait-timeout";

import {GlobalEventQueue} from "../../../../../browser/global-event-queue";
import {ModalService3}    from "../../../../../modal-service-3/modal-service-3";

export const ConfirmDialog = ({next: rootNext}:{
    next : Link<React.ReactNode, {
        show : (props:{
            actionName           ?: string,
            actionContent        ?: string,
            buttons              ?: {
                confirmLabel     ?: string,
                cancelLabel      ?: string,
            },
            message               : string | JSX.Element,
            passiveCloseResponse ?: boolean
        }) => Promise<boolean>,
    }>,
}): JSX.Element => cs(
    ["modal", ({}, next) => ModalService3<any>({
        xToClose: false,
        top: 100,
        width: 400,
        contentService: ({next: next1, ...mo}) => next1({
            onPassiveClose: () => mo.params.resolve(mo.params.passiveCloseResponse??false),
            content: next(mo),
        }),
        xdQaName: "Confirm",
        rootNext: (modal) => rootNext({
            show: (args) => new Promise((resolve) => {
                modal.show({...args, resolve});
            }),
        }),
    })],
    ["onProceed", ({modal}, next) => next(async () => {
        await modal.params.onProceed?.();
        modal.close();
        await waitTimeout(300);
        modal.params.resolve(true);
    })],
    ["actionName", ({modal}, next) => next(modal.params.actionName ?? "proceed")],
    ["actionContent", ({modal, actionName}, next) => next(modal.params.actionContent || (!!actionName && `Are you sure you want to ${actionName}?`))],
    ({modal, onProceed, actionContent, actionName}) => (
        <div className="confirm-dialog-54o" onClick={(e) => e.stopPropagation()}>
            <div className="content">
                <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                    {modal.params.message}
                </div>
                {actionContent && (
                    <div className="sub-text" xd-qa-type="label" xd-qa-name="Confirm Question">
                        {actionContent}
                    </div>
                )}
            </div>
            <div className="footer">
                <button
                    className="cancel"
                    xd-qa-type="button"
                    xd-qa-name="Confirm Cancel"
                    onClick={() => {
                        modal.params.onCancel?.();
                        modal.params.resolve(false);
                        modal.close();
                    }}
                >
                    {modal.params.buttons?.cancelLabel ?? "Cancel"}
                </button>

                {OnGlobalKeyDownEnter({
                    action: onProceed,
                })}

                <button
                    className="proceed"
                    xd-qa-type="button"
                    xd-qa-name={"Confirm "+ (modal.params.buttons?.confirmLabel ?? upperCase1(actionName))}
                    onClick={onProceed}
                >
                    {modal.params.buttons?.confirmLabel ?? upperCase1(actionName)}
                </button>
            </div>
        </div>
    ),
);

const OnGlobalKeyDownEnter = GlobalEventQueue({
    eventName: "keydown",
    surCheck: (e) => e.key === "Enter",
});